<template>
  <div>
    <nav-header ref="navHeader"
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showNavbar="p_showNavbar"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal"
      ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
      <!--<span style="margin-right:10px;" slot="orderList">我的订单</span>-->
    </nav-bread>
    <div class="mg70">
      <svg style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1"
           xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <symbol id="icon-add" viewBox="0 0 31 32">
            <title>add</title>
            <path class="path1"
                  d="M30.745 15.152h-14.382v-14.596c0-0.308-0.243-0.557-0.543-0.557s-0.543 0.249-0.543 0.557v14.596h-14.665c-0.3 0-0.543 0.249-0.543 0.557s0.243 0.557 0.543 0.557h14.665v15.177c0 0.307 0.243 0.557 0.543 0.557s0.543-0.249 0.543-0.557v-15.177h14.382c0.3 0 0.543-0.249 0.543-0.557s-0.243-0.557-0.543-0.557z"></path>
          </symbol>
          <symbol id="icon-ok" viewBox="0 0 32 32">
            <title>ok</title>
            <path class="path1"
                  d="M14.084 20.656l-7.845-9.282c-1.288-1.482-3.534-1.639-5.016-0.351s-1.639 3.534-0.351 5.016l10.697 12.306c1.451 1.669 4.057 1.623 5.448-0.096l18.168-22.456c1.235-1.527 0.999-3.765-0.528-5.001s-3.765-0.999-5.001 0.528l-15.573 19.337z"></path>
          </symbol>
          <symbol id="icon-edit" viewBox="0 0 32 32">
            <title>edit</title>
            <path class="path1"
                  d="M28.287 8.51l-4.805-4.806 0.831-0.831c0.472-0.472 1.086-0.777 1.564-0.777 0.248 0 0.452 0.082 0.622 0.253l3.143 3.144c0.539 0.54 0.133 1.529-0.524 2.186l-0.831 0.831zM26.805 9.992l-1.138 1.138-4.805-4.806 1.138-1.138 4.805 4.806zM24.186 12.612l-14.758 14.762-4.805-4.806 14.758-14.762 4.805 4.806zM7.379 28.288l-4.892 1.224 1.223-4.894 3.669 3.67zM31.123 4.011l-3.143-3.144c-0.567-0.567-1.294-0.867-2.103-0.867-1.036 0-2.174 0.52-3.045 1.391l-20.429 20.436c-0.135 0.134-0.23 0.302-0.276 0.487l-2.095 8.385c-0.089 0.355 0.017 0.736 0.276 0.995 0.198 0.198 0.461 0.307 0.741 0.307 0.085 0 0.171-0.010 0.254-0.031l8.381-2.096c0.185-0.047 0.354-0.142 0.487-0.276l20.43-20.436c1.409-1.41 2.042-3.632 0.524-5.15v0z"></path>
          </symbol>
          <symbol id="icon-del" viewBox="0 0 32 32">
            <title>delete</title>
            <path class="path1"
                  d="M11.355 4.129v-2.065h9.29v2.065h-9.29zM6.194 29.935v-23.742h19.613v23.742h-19.613zM30.968 4.129h-8.258v-3.097c0-0.569-0.463-1.032-1.032-1.032h-11.355c-0.569 0-1.032 0.463-1.032 1.032v3.097h-8.258c-0.569 0-1.032 0.463-1.032 1.032s0.463 1.032 1.032 1.032h3.097v24.774c0 0.569 0.463 1.032 1.032 1.032h21.677c0.569 0 1.032-0.463 1.032-1.032v-24.774h3.097c0.569 0 1.032-0.463 1.032-1.032s-0.463-1.032-1.032-1.032v0z"></path>
            <path class="path2"
                  d="M10.323 9.806c-0.569 0-1.032 0.463-1.032 1.032v14.452c0 0.569 0.463 1.032 1.032 1.032s1.032-0.463 1.032-1.032v-14.452c0-0.569-0.463-1.032-1.032-1.032z"></path>
            <path class="path3"
                  d="M16 9.806c-0.569 0-1.032 0.463-1.032 1.032v14.452c0 0.569 0.463 1.032 1.032 1.032s1.032-0.463 1.032-1.032v-14.452c0-0.569-0.463-1.032-1.032-1.032z"></path>
            <path class="path4"
                  d="M21.677 9.806c-0.569 0-1.032 0.463-1.032 1.032v14.452c0 0.569 0.463 1.032 1.032 1.032s1.032-0.463 1.032-1.032v-14.452c0-0.569-0.463-1.032-1.032-1.032z"></path>
          </symbol>
          <symbol id="icon-clock" viewBox="0 0 32 32">
            <title>clock</title>
            <path class="path1"
                  d="M29.333 16c0-7.364-5.97-13.333-13.333-13.333s-13.333 5.97-13.333 13.333c0 7.364 5.97 13.333 13.333 13.333s13.333-5.97 13.333-13.333v0 0 0 0 0 0zM0 16c0-8.837 7.163-16 16-16s16 7.163 16 16c0 8.837-7.163 16-16 16s-16-7.163-16-16zM14.667 14.667v1.333h2.667v-10.667h-2.667v9.333zM24 18.667h1.333v-2.667h-10.667v2.667h9.333z"></path>
          </symbol>
          <symbol id="icon-question" viewBox="0 0 32 32">
            <title>question</title>
            <path class="path1"
                  d="M16 2.56c7.411 0 13.44 6.029 13.44 13.44s-6.029 13.44-13.44 13.44c-7.411 0-13.44-6.029-13.44-13.44s6.029-13.44 13.44-13.44zM16 0c-8.822 0-16 7.178-16 16s7.178 16 16 16c8.822 0 16-7.178 16-16s-7.178-16-16-16z"></path>
            <path class="path2"
                  d="M16 22.080c-1.059 0-1.92 0.861-1.92 1.92s0.861 1.92 1.92 1.92c1.059 0 1.92-0.861 1.92-1.92s-0.861-1.92-1.92-1.92z"></path>
            <path class="path3"
                  d="M12.16 12.48c0.706 0 1.28-0.574 1.28-1.28 0-1.412 1.148-2.56 2.56-2.56s2.56 1.148 2.56 2.56c0 1.412-1.148 2.56-2.56 2.56-0.706 0-1.28 0.574-1.28 1.28v3.84c0 0.706 0.574 1.28 1.28 1.28s1.28-0.574 1.28-1.28v-2.723c2.224-0.575 3.84-2.616 3.84-4.957 0-2.823-2.297-5.12-5.12-5.12s-5.12 2.297-5.12 5.12c0 0.706 0.574 1.28 1.28 1.28z"></path>
          </symbol>
        </defs>
      </svg>
      <el-container class="container">
        <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 我的地址</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:10px 0 0 0;">
          <el-header class="mhide">我的地址</el-header>
          <el-main>

            <div class="addr-list-wrap">
              <div class="addr-list">
                <ul>
                  <li v-for="(item,index) in addressList" :key="index"  @click="checkAddress(index,item.id)">
                    <dl>
                      <dt>{{item.userName}}</dt>
                      <dd class="address">{{item.provinceName+item.cityName+item.countyName+item.detailInfo}}</dd>
                      <dd class="tel">{{item.telNumber}}</dd>
                    </dl>
                    <div class="addr-opration addr-del">
                      <a href="javascript:;" class="addr-del-btn" @click = "delAddress(item.id)">
                        <i class="el-icon-delete"></i>
                      </a>
                    </div>
                    <div class="addr-opration addr-del" style="right:60px;">
                      <a href="javascript:;" class="addr-del-btn" @click="editAddress(item.id)">
                        <i class="el-icon-edit"></i>
                      </a>
                    </div>
                    <div class="addr-opration addr-default" v-if="item.default == 1">默认地址</div>
                  </li>

                  <li class="addr-new"
                      v-loading="loading">
                    <div class="add-new-inner" @click="addAddress">
                      <i class="icon-add">
                        <svg class="icon icon-add">
                          <use xlink:href="#icon-add"></use>
                        </svg>
                      </i>
                      <p>添加新地址</p>
                    </div>
                  </li>
                </ul>
              </div>

              <!--<div class="shipping-addr-more">-->
              <!--<a class="addr-more-btn up-down-btn" href="javascript:;" @click="expend" v-bind:class="{'open':limit>3}" v-if="limit > 3">-->
              <!--更多{{limit}}-->
              <!--<i class="i-up-down">-->
              <!--<i class="i-up-down-l"></i>-->
              <!--<i class="i-up-down-r"></i>-->
              <!--</i>-->
              <!--</a>-->
              <!--</div>-->
            </div>
          </el-main>
        </el-container>
      </el-container>

      <address-modal v-bind:c_mdshow='p_mdshow' v-on:c_close='p_close' v-on:c_getList="getAddressList" ref="addressAdd">
        <span slot="msg">
          新增地址
        </span>
      </address-modal>

      <address-edit-modal
        ref="addressEdit"
        v-bind:c_mdshow_edit='p_mdshow_edit'
        v-bind:c_addressDetailObj='p_addressDetailObj'
        v-on:c_getAddressDetail="p_getAddressDetail"
        v-on:c_close_edit='p_close_edit'
        v-on:c_getList_edit="getAddressList"
        v-bind:c_editId="p_editId"
        v-bind:c_default="p_default">
        <span slot="msg">
          编辑地址
        </span>
      </address-edit-modal>
    </div>
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
  </div>


</template>

<script>
  import '@/assets/css/index.css'
  import NavLeft from '@/components/NavLeft.vue'
  import Tabbar from '@/components/Tabbar.vue'
  import AddressModal from '@/components/AddressModal'
  import AddressEditModal from '@/components/AddressEditModal'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread.vue'
  import axios from 'axios'
  import {getCookie,delCookie,removeHTMLTag} from "../../util/util";

  export default {
    name: "my-address",
    data(){
      return {
        p_activeIndex:"2",
        addressList:[],
        checkedIndex : 0,
        // limit:3,
        p_mdshow:false,
        p_mdshow_edit:false,
        addressId:'',
        selectedAddrId:'',
        p_editId:"",
        p_addressDetailObj:{},
        loading: true,
        p_default:false,
        p_loginModalFlag:false,
        p_showNavbar: true,
        p_showSearch:true,
        selected: "Mine",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_Filled.png"),
          require("@/assets/me_grey.png")
        ],
      }
    },
    components:{
      NavLeft,Tabbar,
      AddressModal,
      AddressEditModal,
      NavHeader,
      NavBread
    },
    mounted(){
      if (getCookie("_token")) {
        this.getAddressList()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }

    },
    methods:{
      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },

      checkAddress(index,addressId){
        console.log(addressId)
        this.checkedIndex = index;
        this.selectedAddrId = addressId;
        this.p_getAddressDetail(addressId);

      },
      //获取地址列表
      getAddressList() {
        axios.defaults.baseURL = process.env.API_ROOT
        axios.get("/jys/address/user", {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          if(response.data.code == 0){
            this.loading = false
            this.addressList = response.data.list
            // this.limit = this.addressList.length
            for(var i = 0 ; i < this.addressList.length ; i++){
              if(this.addressList[i].default == 1){
                this.checkedIndex = i
              }
            }
            // this.p_getAddressDetail(this.addressList[this.checkedIndex].id)
          }else if(response.data.code == 401){
            this.loading = false
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
            this.$refs.navHeader.logout()
          }
        })
      },

      // 新增 / 修改
      addAddress (id) {
        this.p_mdshow = true;
        this.$refs.addressAdd.getCityData()
      },

      editAddress (id) {
        console.log(id)
        console.log("edit")
        this.p_editId = id
        this.p_mdshow_edit = true;
        this.p_getAddressDetail(id,'edit');
      },

      // 获取地址信息
      p_getAddressDetail(id, flag) {
        axios.get("/jys/address/user", {
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response) => {
          if(response.data.code == 0){
            let addressList = response.data.list
            for(var i= 0; i < addressList.length;i++){
              if(id == addressList[i].id){
                this.p_addressDetailObj = addressList[i]
                this.p_default = addressList[i].default == 1 ? true : false
                console.log(this.p_addressDetailObj)
                this.$store.commit("updateAddressDetail", this.p_addressDetailObj);
                if(flag === 'edit'){
                  this.$refs.addressEdit.init(this.p_addressDetailObj)
                }
              }
            }
          }
        })
      },

      p_close(){
        this.p_mdshow = false;
        this.p_mdshow2 = false;
      },
      p_close_edit(){
        this.p_mdshow_edit = false;
      },
      delAddress(addressId){

        if(this.addressList.length > 1){
          // this.p_mdshow = true;
          this.addressId = addressId;

          this.$confirm('此操作将永久删除该地址, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
            this.delAddressConfirm(addressId)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

        }else{
          //如果只剩一条数据,提示不能删除
          this.p_mdshow2 = true;
          this.$alert('当前只有一条地址信息,无法删除', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              // this.$message({
              //   type: 'info',
              //   message: `action: ${ action }`
              // });
            }
          });
        }

      },
      delAddressConfirm(id){
        axios.delete("/jys/address/" + id,{
          headers:{
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((response)=>{
          let res = response.data;
          if(res.code == 0){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getAddressList();
          }
        })
      },
    }
  }
</script>

<style scoped>
  .addr-list li{
    width:31%;
    margin: 0 2% 2% 0;
  }
  .addr-list li dt,.addr-list li dd{
    text-align: left;
  }
  /deep/ .el-form{
    width: 95%!important;
  }
  .mshow{
    display: none;}
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .addr-list li{
      width: 100%!important;
    }
    /deep/ .container{
      width: 95%!important;
    }
    /deep/ .el-loading-mask {
      z-index: 2;}
    /deep/ .el-dialog {
      width: 98%!important;
    }

    /deep/ .md-modal {
      margin-top: -207px!important;
    }
    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0 -14px 0 -6px;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .mshow{
    display: inline-block;}
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }
    .addr-list li dt {
      font-size: 14px;
      font-weight: bold;
      line-height: 14px;
    }
    .addr-list li dd{
      color:#888;
      font-size: 11px;
    }
    .mhide{
        display: none;}
.addr-list li dt {
      line-height: 1.6rem;
    }
    .el-main{
      padding: 3px;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel{
      display: none!important;
    }
    /deep/ .out{
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }
    .mg70{
      margin-bottom: 70px;
    }  }
</style>



// WEBPACK FOOTER //
// src/pages/user/MyAddress.vue